import React from 'react';
import {useWindowDimensions, View} from 'react-native';
import {get} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './FqvFibcCount.style';

interface FqvFibcCountProps {
  tt: (key: string, value: string) => string;
  item: {
    fqv: string;
    fibcCoachTeamsCount: number;
  };
}

export const FqvFibcCount: React.FC<FqvFibcCountProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = {fqv: '', fibcCoachTeamsCount: 0},
}: FqvFibcCountProps) => {
  const {fontScale} = useWindowDimensions();
  const isLargeFont = fontScale > 1.2;
  const fqv = get(item, 'fqv', '');
  const fibcCoachTeamsCount = get(item, 'fibcCoachTeamsCount', '');

  return (
    <View
      style={[
        styles.attributes,
        isLargeFont && {flexDirection: 'column', alignItems: 'flex-start'},
      ]}>
      <View
        style={{flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="button"
          emphasis="medium">
          {tt('fqv', 'FQV')}{' '}
        </Text>
        <FormattedNumber
          // @ts-expect-error TS(2322): Type '{ testID: any; value: any; textEmphasis: str... Remove this comment to see the full error message
          testID={Reports.reportCoachFqv}
          value={fqv}
          textEmphasis="medium"
          boldText={false}
        />
        {!isLargeFont && (
          <Text allowFontScaling maxFontSizeMultiplier={2} emphasis="medium">
            {' '}
            ·{' '}
          </Text>
        )}
      </View>
      <View
        style={{flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="button"
          emphasis="medium">
          {tt('fbcCount', 'FIBC Teams')}{' '}
        </Text>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          testID={Reports.reportCoachFibcCount}
          emphasis="medium">
          {fibcCoachTeamsCount}
        </Text>
      </View>
    </View>
  );
};

export default withTranslation('report.record.fqvFibcCount')(FqvFibcCount);
